import React from 'react'

interface GroupProps extends React.SVGProps<SVGGElement> {}

const Group: React.FC<GroupProps> = ({ children, ...props }) => {
  return <g {...props}>{children}</g>
}

export default Group
